import $ from 'jquery';

const hamburgerEl = '.c-hamburger__button';
const hamburgerItemsEl = '.c-hamburger__item';
const navEl = '.nav';
const navBackgroundEl = '.nav__background';
const navContainerEl = '.nav__container';
const navWrapperEl = '.navd__wrapper';
const navPagePropEl = '.navd__page--prop';
const navListEl = '.navd__list';
const navListLevel2El = '.navd__list--level-2';
const navLinksEl = '.navd__link';
const navLinksLevelRootClass = 'navd__link--level-1';
const navLinksLevel2El = '.navd__link--level-2';
const navLinksLevel3LastEl = '.navd__link--level-3-last';
const jsNavLinkEl = '.js-nav-link';
const navReturnEl = '.js-nav-return';
const bookButtonEl = '.book-now__button';
const subNavBackgroundEl = '.navd__background';
const navLogoEl = '.navd__logo';
const navLogoTextEl = '.navd__logo-text';
const navTaglineEl = '.navd__tagline';
const navPhoneEl = '.navd__phone';
const destinationsMenuEl = '.navd__list--destinations';
const destinationsLinkEl = `${jsNavLinkEl}[data-destinations="1"]`;
const destinationsLinksEl = '.destination-menu__link';

/**
 * Everything of the page itself that can hold focus, and the dialog buttons
 * that stay reachable while the menu is open
 * @type {string}
 */
const pageFocusableEl = 'body a, body button, body input';
const dialogCloseEl = '.dialog-content__close, .vr-tour__dialog-close';

/**
 * Menu opened focus elements
 * The nav links are handled apart from these: which of them are reachable
 * depends on the sub-menu that is open, see navLinksReachable()
 * @type {*[]}
 */
const focusElements = [
  hamburgerEl,
  bookButtonEl,
  navLogoEl,
  navPhoneEl,
  navLogoTextEl,
];

/**
 * Parts of the page that keep working while the menu is open. Everything else
 * at body level is switched off with the inert attribute.
 * Setting tabindex on links, buttons and inputs is not enough on its own: the
 * Cloudflare Turnstile widget of the Contact Form 7 forms renders an iframe,
 * Chrome and Safari put the frame itself in the tab order, and Tab escaped the
 * open menu into it. Firefox steps over the frame, which is why the menu only
 * looked broken in Chrome and Safari. Inert drops the whole subtree from the
 * tab order, from the accessibility tree and from the mouse at once, so no
 * third-party widget can slip through it.
 * The list holds the menu itself plus everything that stacks above it
 * (.cookie-popup and .booking-widget sit over the open menu and have to stay
 * clickable); the tabindex rules below still take those out of the tab order.
 * @type {string}
 */
const inertKeepEl = '.c-hamburger, .nav, .book-now, .cookie-popup, .booking-widget';

/**
 * Marks what the menu switched off, so only that gets switched back on
 * @type {string}
 */
const inertBackupAttr = 'data-nav-inert';

/**
 * Marks the tabindex the menu changed, together with the value the element had
 * before. Other modules set their own tabindex on the same links and buttons
 * (the carousels, the booking calendar, the date picker), and a blanket
 * removeAttr on close would throw those away for good.
 * @type {string}
 */
const tabIndexBackupAttr = 'data-nav-tabindex';

/**
 * logo inverse section
 * Add section class to the list "logoInverseSections" and logo will be white-colored
 * on background of this particular section
 * @type {*[]}
 */
const logoInverseSections = [
  '.hero',
];

/**
 * undefined, 1 - mouse click, mobile device tap
 * 13 - keyboard enter code
 * 32 - keyboard space code
 * @type {*[]}
 */
const keyCodesAvailable = [undefined, 1, 13, 32];

/**
 * The menu transition, kept in step with the durations of navd.scss: the drawer
 * slides for that long, so the tab order and the focus follow it with the same
 * delay
 * @type {number}
 */
const navSlideMs = 300;

/**
 * The container of the drawer waits for the background to finish first
 * @type {number}
 */
const navContainerDelayMs = 350;

/**
 * The return button of a sub-page is focused once it has slid in
 * @type {number}
 */
const returnFocusDelayMs = 100;

/**
 * Does the event open or close the menu: a mouse click, a tap, Enter or Space
 * @param event
 * @return {boolean}
 */
function isActivation(event) {
  return keyCodesAvailable.indexOf(event.keyCode) !== -1;
}

/**
 * Is the desktop drawer the menu of the current viewport
 * @return {boolean}
 */
function isDesktop() {
  // eslint-disable-next-line no-undef
  return $(window).width() >= breakpoints.desktop;
}

/**
 * Custom element toggle
 * @param element
 * @param show boolean {true|false}
 * @return void
 */
function toggleOpen(element, show = false) {
  $(element).toggleClass('open', show === true);
}

/**
 * Switch the page outside the menu off and back on
 * @param off boolean {true|false}
 * @return void
 */
function inertOutside(off) {
  if (off === true) {
    // an open dialog keeps its section alive, the same way the tabindex rules
    // below leave the dialog close buttons reachable
    $('body > *').not(inertKeepEl).not(':has(dialog[open])').each((i, element) => {
      const $element = $(element);

      if (!$element.is('[inert]')) {
        $element.attr('inert', '').attr(inertBackupAttr, '');
      }
    });

    return;
  }

  $(`[${inertBackupAttr}]`).removeAttr('inert').removeAttr(inertBackupAttr);
}

/**
 * Is the destinations menu the level the keyboard is on right now
 * The check follows the class the styles follow: a closed sub-menu is hidden
 * with visibility, so it keeps its box and jQuery still reports it as :visible
 * @return {boolean}
 */
function destinationsOpen() {
  return $(navWrapperEl).find(destinationsLinkEl).hasClass('open');
}

/**
 * The destinations menu of the desktop drawer while it is open
 * @return {jQuery}
 */
function destinationsMenuOpened() {
  return $(navWrapperEl).find(destinationsMenuEl).filter('.open');
}

/**
 * Nav links the open drawer can actually reach
 * The mobile menu builds its items with the same navd__link class, and a link
 * inside a closed sub-menu is only hidden with visibility, so it keeps its box:
 * both would otherwise leave the tab order running through items nobody sees
 * @return {jQuery}
 */
function navLinksReachable() {
  return $(navWrapperEl).find(navLinksEl).filter(
    (i, element) => $(element).closest(`${navListLevel2El}:not(.open)`).length === 0,
  );
}

/**
 * Everything the open drawer leaves in the tab order, in document order
 * Only the menu is walked: the booking widget stacks above it with tabindex="0"
 * on the items of its own closed dropdowns
 * @return {jQuery}
 */
function menuFocusable() {
  return $([hamburgerEl, bookButtonEl].join(', '))
    .add($(navWrapperEl).find('[tabindex="0"]'))
    .filter((i, element) => typeof element.checkVisibility !== 'function'
      || element.checkVisibility({ visibilityProperty: true }));
}

/**
 * Set tabindex, keeping a copy of the value the element came with
 * The copy is written once, so the first value seen is the one that survives a
 * menu that resets its tab order several times while it is open
 * @param elements jQuery
 * @param value number
 * @return void
 */
function tabIndexSet(elements, value) {
  elements.each((i, element) => {
    const $element = $(element);

    if ($element.attr(tabIndexBackupAttr) === undefined) {
      // an element that carried no tabindex is backed up as an empty string
      $element.attr(tabIndexBackupAttr, $element.attr('tabindex') ?? '');
    }

    $element.attr('tabindex', value);
  });
}

/**
 * Put the tab order back the way the menu found it
 * @return void
 */
function tabIndexRestore() {
  $(`[${tabIndexBackupAttr}]`).each((i, element) => {
    const $element = $(element);
    const backup = $element.attr(tabIndexBackupAttr);

    if (backup === '') {
      $element.removeAttr('tabindex');
    } else {
      $element.attr('tabindex', backup);
    }

    $element.removeAttr(tabIndexBackupAttr);
  });
}

/**
 * Take the page and the whole drawer out of the tab order
 * What stays reachable is put back afterwards, by the level that is open
 * @return void
 */
function tabOrderReset() {
  tabIndexSet($(pageFocusableEl).not(dialogCloseEl), -1);
  // the nav links are spans as well as anchors, so both states are set here
  tabIndexSet($(navLinksEl), -1);
}

/**
 * Menu ADA Tab navigation
 * @param focus boolean {true|false}
 * @return void
 */
function menuADA(focus) {
  if (focus === true) {
    $('body').addClass('overflow-hidden menu-open');
    inertOutside(true);
    tabOrderReset();

    tabIndexSet($(focusElements.join(', ')), 0);
    tabIndexSet(navLinksReachable(), 0);

    // the return button is in the tab order only while a sub-page is slid in
    tabIndexSet($(navReturnEl).filter('.open'), 0);

    return;
  }

  $('body').removeClass('overflow-hidden menu-open');
  inertOutside(false);
  tabIndexRestore();
}

/**
 * Special ADA function for destinations menu
 * Only the elements of the menu itself are touched: a blanket pass over every
 * div and span leaves tabindex attributes all over the page, and those outlive
 * the menu because nothing takes them off again
 * @return void
 */
function menuADADestinations() {
  // Keep the page outside the menu switched off, whichever path got us here
  inertOutside(true);

  // Take the whole drawer out of the tab order first
  tabOrderReset();

  // Allow ONLY the destinations menu that is open, plus the way out of it
  tabIndexSet($([hamburgerEl, bookButtonEl].join(', ')), 0);
  tabIndexSet(
    destinationsMenuOpened()
      .find([navReturnEl, destinationsLinksEl, navLinksLevel3LastEl].join(', ')),
    0,
  );
}

/**
 * Navigation toggle
 * @param show boolean {true|false}
 * @return void
 */
function navToggle(show = false) {
  const isOpen = show === true;

  $(hamburgerEl).toggleClass('open', isOpen).find(hamburgerItemsEl).toggleClass('open', isOpen);
  $(hamburgerEl).attr('aria-expanded', isOpen.toString());

  if (isOpen) {
    $(navEl).addClass('open');

    setTimeout(() => {
      toggleOpen(navBackgroundEl, true);
    }, 0);

    setTimeout(() => {
      toggleOpen(navContainerEl, true);
    }, navContainerDelayMs);

    menuADA(true);

    return;
  }

  toggleOpen(navContainerEl);

  setTimeout(() => {
    $(navEl).removeClass('open');
  }, navSlideMs);

  menuADA(false);
}

/**
 * Sub-navigation toggle
 * @param list array
 * @param show boolean {true|false}
 * @return void
 */
function subNavToggle(list, show = false) {
  toggleOpen(list, show);

  if (show === true) {
    $(list).find(navLinksLevel2El).removeClass('muted');
  }
}

/**
 * Keep the state exposed by a sub-menu trigger aligned with its visual state.
 * @param elements jQuery|string
 * @param expanded boolean {true|false}
 * @return void
 */
function subNavSetExpanded(elements, expanded = false) {
  $(elements).attr('aria-expanded', expanded ? 'true' : 'false');
}

/**
 * Close all sub-navigations
 * The lists are closed together with their links: they carry the open class
 * too, and a stale one keeps their items in the tab order
 * @return void
 */
function subNavCloseAll() {
  $(jsNavLinkEl).removeClass('open');
  subNavSetExpanded(jsNavLinkEl, false);
  $(navListLevel2El).removeClass('open');
  $(subNavBackgroundEl).removeClass('open');
}

/**
 * Property navigation toggle
 * The sub-page slides in and out by the width of the property page, and the
 * destinations menu follows it with the same offset
 * @param show boolean {true|false} - true slides the property page back in
 * @return void
 */
function navPropToggle(show = false) {
  const slideBack = show === true;
  // the width is read while the page is still visible
  const offset = slideBack ? 0 : $(navPagePropEl).width();

  $(navPagePropEl).css({ visibility: slideBack ? 'visible' : 'hidden' }); // Tab navigation related

  // the return button is the way out of a slid-in sub-page, so it only exists
  // and is reachable while that page is open
  toggleOpen(navReturnEl, !slideBack);

  if (slideBack) {
    tabIndexSet($(navReturnEl), -1);
  } else {
    tabIndexSet($(navReturnEl), 0);
  }

  $(navWrapperEl).css({
    'transition-duration': `${navSlideMs}ms`,
    transform: `translateX(-${offset}px)`,
  });

  $(destinationsMenuEl).toggleClass('sub-menu-open', !slideBack).css({
    '--menu-transition-duration': `${navSlideMs}ms`,
    '--menu-transform-x': `${offset}px`,
  });
}

/**
 * Put the open drawer back to its top level: sub-menus closed, property page
 * slid back in, tagline shown again
 * @return void
 */
function drawerResetToRoot() {
  if ($(jsNavLinkEl).length) {
    subNavCloseAll();
  }

  if ($(navPagePropEl).length) {
    navPropToggle(true);
  }

  toggleOpen(navTaglineEl, true);
}

$(document).on('click tap', hamburgerEl, (event) => {
  if (!isActivation(event) || !isDesktop()) {
    return false;
  }

  if ($(hamburgerEl).hasClass('open')) {
    // reset to root first, so the tab-order restore in navToggle() -> menuADA(false)
    // is the last thing to touch the drawer and leaves no stray tabindex behind
    drawerResetToRoot();
    navToggle();

    return false;
  }

  navToggle(true);
  toggleOpen(navTaglineEl, true);

  return false;
});

$(document).on('click tap', jsNavLinkEl, (event) => {
  if (!isActivation(event)) {
    return false;
  }

  const $link = $(event.currentTarget);

  if ($(navPagePropEl).length) {
    navPropToggle();
  }

  toggleOpen(subNavBackgroundEl, true);

  // every sub-menu of the level, except the one of the link that was used
  $link.closest(navListEl).find(navListEl).each((i, element) => {
    const $list = $(element);
    const $listLink = $list.prev(jsNavLinkEl);

    if ($listLink.data('id') !== $link.data('id')) {
      $listLink.removeClass('open');
      subNavSetExpanded($listLink, false);
      subNavToggle($list);
    }
  });

  $(navLinksLevel2El).addClass('muted');
  $link.removeClass('muted').toggleClass('open');
  subNavSetExpanded($link, $link.hasClass('open'));

  if ($link.hasClass('open')) {
    subNavToggle($link.next(navListEl), true);
    toggleOpen(navTaglineEl);

    // the tab order follows the sub-menu that just opened, so it is rebuilt
    // here and not before the toggle above
    if ($link.is(destinationsLinkEl)) {
      setTimeout(() => {
        menuADADestinations();
        // Focus on first element of destinations menu
        destinationsMenuOpened().find(navReturnEl).first().focus();
      }, navSlideMs);

      return false;
    }

    menuADA(true);

    return false;
  }

  $(subNavBackgroundEl).removeClass('open');
  subNavToggle($link.next(navListEl));

  if ($link.hasClass(navLinksLevelRootClass)) {
    toggleOpen(navTaglineEl, true);
  }

  // the sub-menu is closing here, the drawer itself stays open
  menuADA(true);

  // the element that had focus is now hidden, so focus goes back to the toggle
  $link.focus();

  return false;
});

$(document).on('click tap keyup', navReturnEl, (event) => {
  if (!isActivation(event)) {
    return false;
  }

  drawerResetToRoot();

  // Return normal ADA state when going back
  menuADA(true);
  setTimeout(() => {
    // Set focus on destinations link after menu transition
    $(navWrapperEl).find(destinationsLinkEl).focus();
  }, returnFocusDelayMs);

  return false;
});

// Keep Tab inside the open menu and let Escape step back out of it
$(document).on('keydown', (event) => {
  if (!$(navEl).hasClass('open') || !isDesktop()) {
    return;
  }

  const { key } = event;

  if (key === 'Escape') {
    if (destinationsOpen()) {
      $(navWrapperEl).find(destinationsLinkEl).click();
      return;
    }

    $(hamburgerEl).click().focus();
    return;
  }

  if (key !== 'Tab') {
    return;
  }

  const focusableElements = menuFocusable();
  const firstElement = focusableElements.first()[0];
  const lastElement = focusableElements.last()[0];

  if (!firstElement || !lastElement) {
    return;
  }

  const { activeElement } = document;

  if (event.shiftKey) {
    // Shift + Tab - move backward
    if (activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    }
  } else if (activeElement === lastElement) {
    // Tab - move forward
    event.preventDefault();
    firstElement.focus();
  }
});

$(window).bind('load scroll resize', () => {
  // eslint-disable-next-line no-undef
  elemColorByWindowScroll(hamburgerEl, logoInverseSections);
});
